import React, { useState, useEffect, useRef } from 'react';
import SwapCard from './components/SwapCard';
import ProfileCard from './components/ProfileCard';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [activeTab, setActiveTab] = useState('swap');
  // Состояние для показа заставки с видео
  const [showSplash, setShowSplash] = useState(true);
  // Состояние, имитирующее загрузку страницы (если данные ещё не загрузились, можно установить false)
  const [pageLoaded, setPageLoaded] = useState(false);
  const videoRef = useRef(null);

  window.Telegram.WebApp.ready();
  window.Telegram.WebApp.expand();

  // Симулируем, что страница загружена сразу.
  useEffect(() => {
    setPageLoaded(true);
  }, []);

  // Обработчик окончания воспроизведения видео
  const handleVideoEnded = () => {
    // Если страница загружена, скрываем заставку, иначе запускаем видео заново
    if (pageLoaded) {
      setShowSplash(false);
    } else if (videoRef.current) {
      videoRef.current.play();
    }
  };

  // Если заставка активна, отображаем видео на весь экран
  if (showSplash) {
    return (
      <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
        <video
          ref={videoRef}
          src="/access/animation.mp4" // Видео из папки public/access/animation.mp4
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnded}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    );
  }

  // После завершения заставки отображаем основной контент
  return (
    <div style={{ padding: '13px' }}>
      <div>
        {activeTab === 'swap' && <SwapCard />}
        {activeTab === 'profile' && <ProfileCard />}
      </div>

      <div>
        <nav
          style={{
            marginBottom: '16px',
            bottom: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <button
            onClick={() => setActiveTab('swap')}
            className='btn'
            style={{ backgroundColor: '#60BDFF', borderRadius: 20, padding: 15, width: 155, height: 60 }}
          >
            <h4>
              <i className="bi bi-arrow-left-right"></i> Swap
            </h4>
          </button>
          <button
            onClick={() => setActiveTab('profile')}
            className='btn'
            style={{ backgroundColor: '#60BDFF', borderRadius: 20, padding: 15, width: 155, height: 60 }}
          >
            <h3>
              <i className="bi bi-person-fill"></i> Profile
            </h3>
          </button>
        </nav>
      </div>
    </div>
  );
}

export default App;
